import React from 'react'
import { useAppSelector } from 'store/hooks'

import Activity from 'components/Shared/Activity/Activity'

import { selectLocalLoader } from 'lib/helpers/selectors'

interface Props {}

const LoaderHub: React.FC<Props> = props => {
  const loader = useAppSelector(selectLocalLoader)
  const node = loader.show ? (
    <Activity className='shared-loader' size={60} color="primary" message={loader.message} />
  ) : null
  return node
}

export default LoaderHub
